var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9458_103520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7408 25.323L31.8103 37.3896L20.8052 31.6827L20.461 31.5042L20.1163 31.6819L9.11353 37.3523L11.2188 25.2857L11.2872 24.8938L11.0011 24.6174L2.12743 16.0444L14.4317 14.3215L14.8207 14.267L14.9974 13.9163L20.5357 2.92533L26.0008 13.9128L26.1757 14.2643L26.5642 14.3209L38.8726 16.1148L29.961 24.6548L29.6734 24.9304L29.7408 25.323Z",
    stroke: "url(#paint0_linear_9458_103520)",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9458_103520",
    x1: 0.505812,
    y1: 19.9989,
    x2: 40.4937,
    y2: 19.9989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3172,
    stopColor: "#EF9000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#F3F952"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9458_103520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineStar);
export default __webpack_public_path__ + "static/media/outlineStar.d6cb3915f4d009a7c1e9e947107643a4.svg";
export { ForwardRef as ReactComponent };